import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/HomeTransferOrderDefaults'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class HomeTransferOrderDefaultsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "HomeTransferOrderDefaultsStore",
			variables: false,
		})
	}
}

export async function load_HomeTransferOrderDefaults(params) {
  await initClient()

	const store = new HomeTransferOrderDefaultsStore()

	await store.fetch(params)

	return {
		HomeTransferOrderDefaults: store,
	}
}
